export default {
      id: "solar-panel-usage",
      viewBox: "0 0 17.11 13.399",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#solar-panel",
      toString: function () {
        return this.url;
      }
    }